import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface RegistrationSuccessResponse {
  message: string;
  user_id: number;
}

export interface RegistrationErrorResponse {
  message: string;
}

@Injectable({ providedIn: 'root' })
export class RegistrationService {
  constructor(private http: HttpClient) {}

  register(email: string, captcha: string): Observable<RegistrationSuccessResponse | RegistrationErrorResponse> {
    const sanitizedEmail = email.trim().toLowerCase();
    return this.http.post<RegistrationSuccessResponse | RegistrationErrorResponse>(`${environment.explainApiUrl}auth/sign_up`, {
      email: sanitizedEmail,
      captcha_token: captcha,
    });
  }
}
